export default {
  name: 'text-view',
  props: ['value'],
  render() {
    return <div>{this.value}</div>;
  },
};
